// Chakra imports
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Icon,
  Input,
  Link,
  Switch,
  Text,
  Image,
  useColorModeValue,
  Spacer,
} from "@chakra-ui/react";
// Assets
import BasicImage from "assets/img/BasicImage.png";
import React, { useState } from "react";
import { ReactComponent as GoogleIcon } from "assets/svg/google.svg";

import AuthBasic from "layouts/AuthBasic";
import { getAuth, signInWithRedirect, GoogleAuthProvider } from "firebase/auth";
import { setUserData, setIsAuthenticated } from "contexts/userProfile";
import { useHistory } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import logo from "assets/img/logo.png";
import { Modal, ModalOverlay, ModalContent } from "@chakra-ui/react";
import Lottie from "lottie-react";
import addAnimation from "assets/animations/add.json";

function SignIn() {
  const provider = new GoogleAuthProvider();
  const auth = getAuth();
  const textColor = useColorModeValue("gray.400", "white");
  const bgForm = useColorModeValue("white", "navy.800");
  const titleColor = useColorModeValue("gray.700", "blue.500");
  const colorIcons = useColorModeValue("gray.700", "white");
  const bgIcons = useColorModeValue("trasnparent", "navy.700");
  const bgIconsHover = useColorModeValue("gray.50", "whiteAlpha.100");
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);

  const signInWithGoogle = () => {
    signInWithRedirect(auth, provider)
      .then((result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        const user = result.user;
        setUserData(user);
        setIsAuthenticated(true);
      })
      .catch((error) => {
        console.log(error);
        const errorCode = error.code;
        const errorMessage = error.message;
        const email = error.customData.email;
        const credential = GoogleAuthProvider.credentialFromError(error);
      });
  };

  return (
    <>
      <Flex
        as="nav"
        align="center"
        justify="space-between"
        wrap="wrap"
        m={2}
        bg="transparent"
        color="white"
      >
        <Flex align="center">
          <Image src={logo} height="80px" objectFit="contain" alt="CogniSigner Logo" />
        </Flex>

        <Spacer />

        <Button
          bg="transparent"
          leftIcon={<FaHome />}
          onClick={() => {
            setIsOpen(true);
            setTimeout(() => {
              setIsOpen(false);
              history.push("/");
            }, 2000);
          }}
        />
      </Flex>
      <AuthBasic title="Welcome!" description="Feel free to Sign In" image={BasicImage} mt={10}>
        <Flex
          w="100%"
          h="100%"
          minHeight="60vh"
          alignItems="center"
          justifyContent="center"
          mb="60px"
          mt={{ base: "60px", md: "0px" }}
        >
          <Flex
            zIndex="2"
            direction="column"
            w="445px"
            background="transparent"
            borderRadius="15px"
            p="40px"
            mx={{ base: "100px" }}
            mb={{ base: "20px", md: "auto" }}
            bg={bgForm}
            boxShadow={useColorModeValue("0px 5px 14px rgba(0, 0, 0, 0.05)", "unset")}
          >
            <Text fontSize="xl" color={textColor} fontWeight="bold" textAlign="center" mb="22px">
              Sign In with
            </Text>
            <HStack spacing="15px" justify="center" mb="22px">
              {/* <Flex
              justify="center"
              align="center"
              w="75px"
              h="75px"
              borderRadius="8px"
              border={useColorModeValue("1px solid", "0px")}
              borderColor="gray.200"
              cursor="pointer"
              transition="all .25s ease"
              bg={bgIcons}
              _hover={{ bg: bgIconsHover }}
            >
              <Link href="#">
                <Icon as={FaFacebook} color={colorIcons} w="30px" h="30px" />
              </Link>
            </Flex> */}
              <Flex
                justify="center"
                align="center"
                w="75px"
                h="75px"
                borderRadius="8px"
                border={useColorModeValue("1px solid", "0px")}
                borderColor="gray.200"
                cursor="pointer"
                transition="all .25s ease"
                bg={bgIcons}
                _hover={{ bg: bgIconsHover }}
                onClick={signInWithGoogle}
              >
                <GoogleIcon color={colorIcons} width="30px" height="30px" />
              </Flex>
            </HStack>
          </Flex>
        </Flex>
        <Modal isOpen={isOpen} isCentered>
          <ModalOverlay />
          <ModalContent
            backgroundColor="transparent"
            boxShadow="none"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Lottie animationData={addAnimation} style={{ width: 400, height: 400 }} />
          </ModalContent>
        </Modal>
      </AuthBasic>
    </>
  );
}

export default SignIn;
